import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./Time_Modal.css";
import Common_Btn from "../../common-btn/Common_Btn";

const Time_Modal = ({
  show,
  onHide,
  openingTime,
  setOpeningTime,
  openingPeriod,
  setOpeningPeriod,
  closingTime,
  setClosingTime,
  closingPeriod,
  setClosingPeriod,
  onDone,
}) => {
  const [errors, setErrors] = useState({ opening: "", closing: "" });

  // ─── Reset errors when modal opens ───────────────────────────
  useEffect(() => {
    if (show) setErrors({ opening: "", closing: "" });
  }, [show]);

  // ─── Validate HH:MM format (01–12 : 00–59) ───────────────────
  const isValidTime = (value) => /^(0[1-9]|1[0-2]):[0-5][0-9]$/.test(value);

  // ─── Format on-the-fly: auto-insert colon after 2 digits ─────
  const formatTimeInput = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 4);
    if (digits.length >= 3) return `${digits.slice(0, 2)}:${digits.slice(2)}`;
    return digits;
  };

  const handleOpeningChange = (e) => {
    const formatted = formatTimeInput(e.target.value);
    setOpeningTime(formatted);
    setErrors((prev) => ({ ...prev, opening: "" }));
  };

  const handleClosingChange = (e) => {
    const formatted = formatTimeInput(e.target.value);
    setClosingTime(formatted);
    setErrors((prev) => ({ ...prev, closing: "" }));
  };

  // ─── Validate before calling onDone ──────────────────────────
  const handleDone = () => {
    const newErrors = { opening: "", closing: "" };

    if (!openingTime) {
      newErrors.opening = "Opening time is required";
    } else if (!isValidTime(openingTime)) {
      newErrors.opening = "Enter a valid time (e.g. 06:00)";
    }

    if (!closingTime) {
      newErrors.closing = "Closing time is required";
    } else if (!isValidTime(closingTime)) {
      newErrors.closing = "Enter a valid time (e.g. 03:00)";
    }

    if (newErrors.opening || newErrors.closing) {
      setErrors(newErrors);
      return;
    }

    onDone();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      className="time_modal_main"
    >
      <div className="time_modal">
        <div className="time_modal_header">
          <h5>Timing</h5>
          <span className="close_btn" onClick={onHide}>×</span>
        </div>

        <div className="time_modal_body">
          <div className="time_row">

            {/* Opening */}
            <div className="row mb-3">
              <div className="col-lg-6">
                <label>
                  Opening <span className="text-danger">*</span>
                </label>
                <div className="time_input_group">
                  <input
                    type="text"
                    value={openingTime}
                    onChange={handleOpeningChange}
                    placeholder="06:00"
                    maxLength={5}
                    className={errors.opening ? "input_error" : ""}
                  />
                  <select
                    value={openingPeriod}
                    onChange={(e) => setOpeningPeriod(e.target.value)}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
                {errors.opening && (
                  <small className="text-danger d-block mt-1">{errors.opening}</small>
                )}
              </div>
            </div>

            {/* Closing */}
            <div className="row mb-3">
              <div className="col-lg-6">
                <label>
                  Closing <span className="text-danger">*</span>
                </label>
                <div className="time_input_group">
                  <input
                    type="text"
                    value={closingTime}
                    onChange={handleClosingChange}
                    placeholder="03:00"
                    maxLength={5}
                    className={errors.closing ? "input_error" : ""}
                  />
                  <select
                    value={closingPeriod}
                    onChange={(e) => setClosingPeriod(e.target.value)}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
                {errors.closing && (
                  <small className="text-danger d-block mt-1">{errors.closing}</small>
                )}
              </div>
            </div>

          </div>

          <div className="form_btn_holder">
            <Common_Btn btnText="Done" onClick={handleDone} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Time_Modal;